export default __webpack_public_path__ + "static/media/final-2.24bb8ff8.png";